// extracted by mini-css-extract-plugin
export default {"container":"tag_container__Hcfk9","black_label":"tag_black_label__tccbn"};